import { observer } from "mobx-react";

import Button from "components/UI/Button/Button";
import Slider from "components/UI/Slider/Slider";
import { ProjectsActiveReportAuctionSliderMark } from "./ProjectsActiveReportAuctionSliderMark/ProjectsActiveReportAuctionSliderMark";

import AppStore from "AppStore";
import messageBoxStore from "MessageBox/MessageBoxStore";
import popupStore from "components/Popup/PopupStore";

import client, { ApiError } from "client";

import "./ProjectAuctionSlider.scss";

const ProjectAuctionSlider = observer(({ store, project, isMobile }) => {
  const handleChange = (newValue) => {
    store.setValueProject(newValue);
  };

  const handleRaiseProjectPrice = async () => {
    if (!project) return;

    const additionalPricePerTask = store.markValuesProject[store.valueProject];
    const newExtraPricePerTask = additionalPricePerTask;
    
    const applicableTasks = popupStore.getApplicableTasks(project);
    const applicableTasksCount = applicableTasks.length;
    const totalCost = store.roundToCents(additionalPricePerTask * applicableTasksCount);

    if (applicableTasksCount === 0) {
      return messageBoxStore.showError(
        "Нет задач для применения повышенной ставки!"
      );
    }

    try {
      const userBalance = await client.getBalance();

      if (userBalance < totalCost) {
        return messageBoxStore.showError(
          "Недостаточно средств!",
          null,
          "Пополнить",
          () => {
            popupStore.open("paymodal");
          }
        );
      }

      store.setProjectDataForRaisePrice(project, newExtraPricePerTask);
      AppStore.currentMarketStore.setIsCreatingProject(false);
      store.setAgreedRulesRaisePrice(true);
      store.open("accept-rules");
    } catch (e) {
      if (e instanceof ApiError) {
        messageBoxStore.showError(e.message);
      } else {
        messageBoxStore.showError(
          "Произошла ошибка при повышении ставки для проекта"
        );
      }
    }
  };

  const additionalPrice = store.markValuesProject[store.valueProject];
  const applicableTasks = popupStore.getApplicableTasks(project);
  const applicableTasksCount = applicableTasks.length;
  const totalCost = store.roundToCents(additionalPrice * applicableTasksCount);

  const handleContinueWithoutChangingPrice = () => {
    store.setShowModalAuctionProject(false);
  };

  return (
    <div className="projects-auction-slider">
      <p className="projects-auction-slider__info">Поднять ставку на: <span>+ {store.markValuesProject[store.valueProject]} ₽</span> (за задание)</p>
      <div className="projects-auction-slider__container">
        <div className="projects-auction-slider__container-slider">
          {!isMobile && <span>+ 3 ₽</span>}
          <Slider
            min={0}
            max={9}
            step={1}
            value={store.valueProject}
            handler={handleChange}
            onMouseDown={() => {}}
            onTouchEnd={() => {}}
            thresholdColor="#FED400"
          />
          {!isMobile && <span>+ 25 ₽</span>}
        </div>

        <div>
          {store.markValuesProject.map((mv, index) => (
            <ProjectsActiveReportAuctionSliderMark
              key={index}
              store={store}
              value={mv}
            />
          ))}
        </div>
      </div>

      <div className="projects-auction-slider__buttons">
        <Button
          className="projects-auction-slider__button-update"
          title="Ускорить поиск исполнителей"
          boldText={`+ ${totalCost} ₽`}
          onClick={handleRaiseProjectPrice}
          disabled={totalCost === 0}
        />
        <Button
          className="projects-auction-slider__button-continue"
          title="Продолжить без изменений"
          onClick={handleContinueWithoutChangingPrice}
        />
      </div>
    </div>
  );
});

export default ProjectAuctionSlider;
